import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalDrawer: {
    defaultMessage: 'Import Dangerous Goods from CSV',
    id: 'zO3Uzi',
    description: 'Dangerous Goods Import Modal Title',
  },
  createConfigStep: {
    defaultMessage: 'Upload File',
    id: 'IQ2vdL',
    description: 'Title on the first step of the import process',
  },
  createMappingStep: {
    defaultMessage: 'Match Fields',
    id: 'ZUIKqi',
    description: 'Create mapping step title message',
  },
  importResult: {
    id: 'BJOH2h',
    defaultMessage: 'Import Dangerous Goods',
    description: 'Title of import is processing step',
  },
  importResultSuccess: {
    id: 'Qme+Nb',
    defaultMessage: 'Dangerous Goods Successfully Imported',
    description: 'Title of success import',
  },
});

export const fieldsTranslations = defineMessages({
  sku: {
    defaultMessage: 'SKU',
    id: 'avrhcQ',
    description: 'SKU product import column name',
  },
  name: {
    defaultMessage: 'Name',
    id: 'zMpoNu',
    description: 'Name product import column name',
  },
  id_number: {
    defaultMessage: 'UN Number',
    id: 'dlGJNq',
    description:
      "UN Number (abbreviation should not be expanded but it comes from 'United Nations Committee of Experts on the Transport of Dangerous Goods') of Dangerous Goods import column name",
  },
  shipping_name: {
    defaultMessage: 'Shipping Name',
    id: '6+szts',
    description: 'Shipping name of Dangerous Goods import column name',
  },
  technical_name: {
    defaultMessage: 'Technical Name',
    id: 'AWEQCr',
    description: 'Technical Name of Dangerous Goods import column name',
  },
  product_hazard_class: {
    defaultMessage: 'Product Hazard Class',
    id: 'KekabW',
    description: 'Product Hazard Class of Dangerous Goods import column name',
  },
  sub_hazard: {
    defaultMessage: 'Sub Hazard',
    id: '3nyZRO',
    description: 'Sub Hazard of Dangerous Goods import column name',
  },
  packaging_group: {
    defaultMessage: 'Packaging Group',
    id: 'u/NIhS',
    description: 'Packaging Group of Dangerous Goods import column name',
  },
  amount_value: {
    defaultMessage: 'Amount Value',
    id: 'c7MZrF',
    description: 'Amount Value of Dangerous Goods import column name',
  },
  amount_unit: {
    defaultMessage: 'Amount Unit',
    id: 'QYw/Ha',
    description: 'Amount Unit of Dangerous Goods import column name',
  },
  quantity: {
    defaultMessage: 'Quantity',
    id: '+/5MEi',
    description: 'Quantity of Dangerous Goods import column name',
  },
  packaging_type: {
    defaultMessage: 'Packaging Type',
    id: 'xc9y1z',
    description: 'Packaging Type of Dangerous Goods import column name',
  },
  transport_category: {
    defaultMessage: 'Transport Category',
    id: 'hqLnXW',
    description: 'Transport Category of Dangerous Goods import column name',
  },
  radioactive: {
    defaultMessage: 'Radioactive',
    id: 'Y0Dl/K',
    description: 'Radioactive of Dangerous Goods import column name',
  },
  reportable_qty: {
    defaultMessage: 'Reportable Qty',
    id: 'tlL1Ne',
    description: 'Reportable Qty (quantity) of Dangerous Goods import column name',
  },
});
